/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define([], function() {
    'use strict';

    function newFeature(route) {
        return {
            type: 'Feature',
            properties: {summary: route.summary, sections: route.sections, segmentSummary: []}
        };
    }

    function getCoordinates(points) {
        var coordinates = [];
        var i;
        for (i = 0; i < points.length; i += 1) {
            coordinates.push([points[i].longitude, points[i].latitude]);
        }
        return coordinates;
    }

    return function(route) {
        var isMultiLineString = route.legs.length > 1;

        var feature = newFeature(route);
        var i;
        for (i = 0; i < route.legs.length; i += 1) {
            feature.properties.segmentSummary.push(route.legs[i].summary);

            if (route.legs[i].points) {
                feature.geometry = feature.geometry || {
                    coordinates: []
                };

                if (isMultiLineString) {
                    feature.geometry.type = 'MultiLineString';
                    feature.geometry.coordinates.push(getCoordinates(route.legs[i].points));
                } else {
                    feature.geometry.type = 'LineString';
                    feature.geometry.coordinates = getCoordinates(route.legs[i].points);
                }
            }
        }
        if (route.guidance) {
            feature.properties.guidance = route.guidance;
        }
        return feature;
    };
});



// WEBPACK FOOTER //
// ./model/routing/helpers/getRouteFeature.js